import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { socialLinks, communityLinks, INSTAGRAM_WIDGET_ID } from '../../../data/homeContent';
import { trackEvent, analyticsEvents } from '../../../data/mock';

export const SocialSection = () => {
  const ref = useRef(null);
  useEffect(() => {
    if (!INSTAGRAM_WIDGET_ID || !ref.current) return undefined;
    const load = () => {
      if (document.querySelector('script[src*="elfsight"]')) return;
      const s = document.createElement('script'); s.src = 'https://static.elfsight.com/platform/platform.js'; s.defer = true; s.setAttribute('data-use-service-core', ''); document.body.appendChild(s);
    };
    const io = new IntersectionObserver((entries) => { if (entries.some((e) => e.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '600px 0px' });
    io.observe(ref.current);
    return () => io.disconnect();
  }, []);

  return (
    <section ref={ref} className="hv-social hv-dark bg-[#0F2E22] py-24 lg:py-32" data-testid="homepage-social">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-end justify-between gap-8 mb-10">
          <div className="max-w-[720px]">
            <p className="hv-kicker text-xs font-semibold uppercase tracking-[0.18em] text-[#DFC590] mb-5">Einblicke</p>
            <h2 className="text-[#F8F6F0]">Sehen Sie, wie wir arbeiten – bevor Sie anrufen.</h2>
          </div>
          <div className="flex flex-wrap items-center gap-2 mb-2" data-testid="social-cards">
            {socialLinks.map((sl) => (
              <a key={sl.key} href={sl.url} target="_blank" rel="noopener noreferrer" data-testid={`social-card-${sl.key}`} onClick={() => trackEvent(analyticsEvents.SOCIAL_CLICK, { platform: sl.key, location: 'social_section' })} className="hv-icon-btn hv-icon-btn-light !w-auto px-4 gap-2 text-sm">
                <sl.icon className="w-4 h-4" aria-hidden="true" />{sl.label}
              </a>
            ))}
          </div>
        </div>
        {INSTAGRAM_WIDGET_ID ? (
          <div className={`elfsight-app-${INSTAGRAM_WIDGET_ID}`} data-elfsight-app-lazy data-testid="instagram-feed-widget" />
        ) : (
          <a href={socialLinks[0].url} target="_blank" rel="noopener noreferrer" className="hv-card hv-card-dark block bg-[#153B2B] border border-[#2A5A45] rounded-[4px] p-8 text-[#F8F6F0]" data-testid="instagram-feed-placeholder">Aktuelle Reels auf Instagram ansehen</a>
        )}
        <div className="grid md:grid-cols-2 gap-4 mt-10" data-testid="community-links">
          {communityLinks.map((c) => (
            <a key={c.key} href={c.url} target="_blank" rel="noopener noreferrer" data-testid={`community-${c.key}`} onClick={() => trackEvent(analyticsEvents.SOCIAL_CLICK, { platform: c.key, location: 'community' })} className="hv-card hv-card-dark group flex items-center gap-5 bg-[#153B2B] border border-[#2A5A45] rounded-[4px] p-5 lg:p-6">
              <span className="hv-icon-btn hv-icon-btn-light shrink-0"><c.icon className="w-5 h-5" aria-hidden="true" /></span>
              <span className="flex-1">
                <span className="block text-[#F8F6F0] font-medium">{c.label}</span>
                <span className="block text-sm text-[#A9B8A9] mt-1">{c.text}</span>
              </span>
              <ArrowRight className="w-5 h-5 text-[#DFC590] shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
